// Phase P.10 — feature flags. Central switchboard so we can gate whole
// UI blocks without ripping code out. Flip a flag back to `true` and
// the previously-hidden feature returns intact.

// Stripe Connect (per-tenant payout onboarding). Set to `true` when the
// platform is ready to accept tenant Stripe Connect payouts. Currently
// hidden because Connect webhooks + client id are not fully wired for
// live mode. Backend endpoints stay live so we can flip in one line.
export const CONNECT_ENABLED = false;
